import { webApiWithResponse } from "../../../../core/http/httpThunks";

export const deleteProductApi = (userId: string, prodid: string, errorExceptions: string[]) =>
	webApiWithResponse<string>({
		method: "DELETE",
		url: "listing/delprod",
		params: {
			userId,
			prodid,
		},
	}, undefined, errorExceptions);

export default deleteProductApi;
